var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "494.936px",
    height: "494.936px",
    viewBox: "0 0 494.936 494.936",
    style: {
      enableBackground: "new 0 0 494.936 494.936"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m 389.844,216.21603 c -6.743,0 -12.21,5.467 -12.21,12.21 v 156.23594 c 0,23.562 -19.174,42.735 -42.736,42.735 l -208.42361,0 c -23.562,0 -42.735999,-19.174 -42.735999,-42.735 l 0,-234.37697 c 0,-23.562 19.173999,-42.735 42.735999,-42.735 l 168.38437,0 c 6.743,0 12.21,-5.467 12.21,-12.21 0,-6.743 -5.467,-12.21 -12.21,-12.21 l -168.38437,0 c -37.030999,0 -67.156999,30.125 -67.156999,67.155 l 0,234.37697 c 0,37.029 30.126,67.155 67.156999,67.155 l 208.42361,0 c 37.03,0 67.156,-30.126 67.156,-67.155 V 228.42703 c 0,-6.743 -5.467,-12.211 -12.21,-12.211 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 430.49035,79.366923 c -14.72,-14.72 -38.669,-14.714 -53.377,0 l -209.147,209.152997 c -0.28,0.28 -3.434,3.559 -4.251,5.396 l -28.963,65.069 c -2.057,4.619 -1.056,10.027 2.521,13.6 2.337,2.336 5.461,3.576 8.639,3.576 1.675,0 3.362,-0.346 4.96,-1.057 l 65.07,-28.963 c 1.83,-0.815 5.114,-3.97 5.396,-4.25 l 209.152,-209.146 c 7.131,-7.131 11.06,-16.61 11.06,-26.692 0,-10.080997 -3.929,-19.561997 -11.06,-26.685997 z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditButton);
export default __webpack_public_path__ + "static/media/editButton.9bfb4d02.svg";
export { ForwardRef as ReactComponent };